module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/clientes"
    }
  }, [_vm._v("Volver a la lista")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#sucursales",
      "aria-controls": "sucursales",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Sucursales")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#form-sucursal",
      "aria-controls": "sucursales",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Form sucursal")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#form-usuario",
      "aria-controls": "usuario",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Nuevo usuario")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#lista-usuarios",
      "aria-controls": "lista usuarios",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Usuarios admin")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active in fade",
    attrs: {
      "role": "tabpanel",
      "id": "general"
    }
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Razón Social")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cliente.razonSocial),
      expression: "cliente.razonSocial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cliente.razonSocial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cliente.razonSocial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onGuardarCliente($event)
      }
    }
  }, [_vm._v("Guardar Cliente")])])])])])])]), _vm._v(" "), (_vm.guardadoBD) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "sucursales"
    }
  }, [_c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickCrearSucursal($event)
      }
    }
  }, [_vm._v("Crear sucursal")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sucursales), function(sucursal) {
    return (_vm.sucursales.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(sucursal.denominacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sucursal.direccion.direccion))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setSucursalActiva(sucursal._id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setSucursalEdicion(sucursal)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user"
    })])])])])]) : _vm._e()
  }))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    staticClass: "tab-pane",
    attrs: {
      "id": "form-sucursal"
    }
  }, [_c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.editandoSucursalGuardada) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Editando sucursal " + _vm._s(_vm.sucursal.denominacion))]) : _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Nueva sucursal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Denominación")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.denominacion),
      expression: "sucursal.denominacion"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sucursal.denominacion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.denominacion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dirección")]), _vm._v(" "), (_vm.mapsLoaded) ? _c('vue-google-autocomplete', {
    ref: "direccion",
    attrs: {
      "id": "map",
      "country": "ar",
      "classname": "form-control",
      "placeholder": "Escriba la dirección"
    },
    on: {
      "placechanged": _vm.getAddressData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Torre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direccion.torre),
      expression: "direccion.torre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.direccion.torre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.direccion.torre = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Piso")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direccion.piso),
      expression: "direccion.piso"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.direccion.piso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.direccion.piso = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Departamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direccion.departamento),
      expression: "direccion.departamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.direccion.departamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.direccion.departamento = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("LIMITE DE DÍAS PARA REALIZACIÓN DE PEDIDOS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.daysToCancel),
      expression: "sucursal.daysToCancel"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "7"
    },
    domProps: {
      "value": (_vm.sucursal.daysToCancel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.daysToCancel = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("HORA LÍMITE PARA REALIZACIÓN DE PEDIDOS")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-timepicker', {
    attrs: {
      "hide-clear-button": ""
    },
    model: {
      value: (_vm.sucursal.hoursToCancel),
      callback: function($$v) {
        _vm.sucursal.hoursToCancel = $$v
      },
      expression: "sucursal.hoursToCancel"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Proveedores")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asignacion.proveedorActivo),
      expression: "asignacion.proveedorActivo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.asignacion.proveedorActivo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeProveedor]
    }
  }, [_c('option', [_vm._v("Seleccione un proveedor")]), _vm._v(" "), _vm._l((_vm.proveedores), function(proveedor) {
    return _c('option', {
      key: proveedor._id,
      domProps: {
        "value": proveedor._id
      }
    }, [_vm._v(_vm._s(proveedor.razonSocial))])
  })], 2), _vm._v(" "), (!_vm.$v.asignacion.proveedorActivo.required && _vm.mostrarErroresProveedor) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar un proveedor")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Combos del proveedor")]), _vm._v(" "), (_vm.proveedorSeleccionado) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asignacion.comboSeleccionado),
      expression: "asignacion.comboSeleccionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.asignacion.comboSeleccionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Seleccione un combo")]), _vm._v(" "), _vm._l((_vm.proveedorSeleccionado.precios), function(precio) {
    return _c('option', {
      domProps: {
        "value": precio.combo._id
      }
    }, [_vm._v(_vm._s(precio.combo.nombre))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.$v.asignacion.comboSeleccionado.required && _vm.mostrarErroresProveedor) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar un combo")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horarios de entrega del Proveedor")]), _vm._v(" "), (_vm.proveedorSeleccionado) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asignacion.horarioSeleccionado),
      expression: "asignacion.horarioSeleccionado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.asignacion.horarioSeleccionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione un horario")]), _vm._v(" "), _vm._l((_vm.proveedorSeleccionado.horariosEntrega), function(horario) {
    return _c('option', {
      domProps: {
        "value": horario
      }
    }, [_vm._v(_vm._s(horario))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.$v.asignacion.horarioSeleccionado.required && _vm.mostrarErroresProveedor) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar un horario")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lunes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.lunes),
      expression: "sucursal.subsidio.lunes"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.lunes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.lunes = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.lunes)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Martes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.martes),
      expression: "sucursal.subsidio.martes"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.martes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.martes = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.martes)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Miércoles")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.miércoles),
      expression: "sucursal.subsidio.miércoles"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.miércoles)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.miércoles = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.miércoles)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Jueves")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.jueves),
      expression: "sucursal.subsidio.jueves"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.jueves)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.jueves = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.jueves)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Viernes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.viernes),
      expression: "sucursal.subsidio.viernes"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.viernes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.viernes = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.viernes)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sábado")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sucursal.subsidio.sábado),
      expression: "sucursal.subsidio.sábado"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sucursal.subsidio.sábado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sucursal.subsidio.sábado = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copiarATodos(_vm.sucursal.subsidio.sábado)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.agregarProveedor($event)
      }
    }
  }, [(_vm.idxSucursalEditada < 0) ? _c('span', [_vm._v("Agregar proveedor asignado")]) : _c('span', [_vm._v("Guardar proveedor asignado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.sucursal.proveedores), function(asociado, idx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.idAProveedor(asociado.proveedor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.idComboATexto(asociado.combo, asociado.proveedor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(asociado.horarioAsignado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("subsidioATexto")(asociado.subsidio)))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickModificar(asociado, idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-edit"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickEliminarProveedor(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-remove"
    })])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickGuardarSucursal($event)
      }
    }
  }, [_vm._v("Guardar sucursal")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    staticClass: "tab-pane",
    attrs: {
      "id": "form-usuario"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [(_vm.idSucursalEdicion) ? _c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("NUEVO USUARIO PARA " + _vm._s(_vm.nombreSucursalEdicion))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.firstName),
      expression: "usuario.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.usuario.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.firstName.minLength || !_vm.$v.usuario.firstName.required) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre no puede estar vacío")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.lastName),
      expression: "usuario.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.lastName.minLength || !_vm.$v.usuario.lastName.required) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El apellido no puede estar vacío")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.email = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.email.required || !_vm.$v.usuario.email.email) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Email no válido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.telefonoCelular),
      expression: "usuario.telefonoCelular"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.telefonoCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.telefonoCelular = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.telefonoFijo),
      expression: "usuario.telefonoFijo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "De su área de trabajo"
    },
    domProps: {
      "value": (_vm.usuario.telefonoFijo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.telefonoFijo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Interno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.interno),
      expression: "usuario.interno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.interno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.interno = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Área")]), _vm._v(" "), _c('div', {
    staticClass: "select",
    model: {
      value: (_vm.usuario.area),
      callback: function($$v) {
        _vm.usuario.area = $$v
      },
      expression: "usuario.area"
    }
  }, [_vm._m(3), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.username),
      expression: "usuario.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.username = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.username.minLength || !_vm.$v.usuario.username.required) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre de usuario es requerido y como mínimo debe tener 3 caracteres")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.password),
      expression: "usuario.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.usuario.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.password = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.password.minLength || !_vm.$v.usuario.password.required) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El password es requerido y como mínimo debe tener 6 caracteres")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Repetir contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.repeat),
      expression: "usuario.repeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.usuario.repeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.repeat = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.usuario.repeat.sameAsPassword && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("No coincide con la contraseña")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_vm._l((_vm.errors), function(error) {
    return (_vm.errors.length > 0) ? _c('ul', {
      staticClass: "list-unstyled danger"
    }, [_c('li', [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(error))])])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickGuardarUsuario($event)
      }
    }
  }, [_vm._v("GUARDAR")])], 2)])]) : _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Debe seleccionar una sucursal de la pestaña Sucursales")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guardadoBD),
      expression: "guardadoBD"
    }],
    staticClass: "tab-pane",
    attrs: {
      "id": "lista-usuarios"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.usuarios), function(usuario) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(usuario.displayName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.sucursalAsociada.denominacion))]), _vm._v(" "), (usuario.sucursalesAdministradas.length > 0) ? _c('td', [(usuario.sucursalesAdministradas.length == 1) ? _c('span', [_vm._v("\n                      " + _vm._s(usuario.sucursalesAdministradas[0].denominacion) + "\n                    ")]) : _c('span', [_vm._v("\n                      " + _vm._s(usuario.sucursalesAdministradas.length) + "\n                    ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-ghost pull-right",
      attrs: {
        "type": "button",
        "title": "Cambiar sucursales administradas"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarSucursalesAdministradas(usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-tags"
    })])]) : _c('td', [_vm._v("\n                    " + _vm._s(usuario.sucursalAsociada.denominacion) + " \n                    "), _c('a', {
      staticClass: "btn btn-xs btn-ghost pull-right",
      attrs: {
        "type": "button",
        "title": "Cambiar sucursales administradas"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarSucursalesAdministradas(usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-tags"
    })])]), _vm._v(" "), _c('td', [(usuario.activado) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [(usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Desactivar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-times"
    })])]) : _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Activar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-plus"
    })])])])])])
  }))])])])])]), _vm._v(" "), (_vm.usuarioActivo) ? _c('div', {
    ref: "modalAdministrarSucursal",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.usuarioActivo.displayName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "smart-form"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.sucursales), function(suc) {
    return _c('div', {
      staticClass: "form-group"
    }, [(suc._id == _vm.usuarioActivo.sucursalAsociada._id) ? _c('span', {
      staticClass: "fa fa-building"
    }) : _c('span', [_c('a', {
      on: {
        "click": function($event) {
          _vm.toggleSucursal(suc)
        }
      }
    }, [(_vm.sucursalSeleccionada(suc)) ? _c('i', {
      staticClass: "fa fa-check-square-o"
    }) : _c('i', {
      staticClass: "fa fa-square-o"
    })])]), _vm._v("\n                    " + _vm._s(suc.denominacion) + "\n                ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        _vm.guardarSucursalesAdministradas()
      }
    }
  }, [_vm._v("Guardar")])])])], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#general",
      "aria-controls": "entradas",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Datos generales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Denominación")]), _vm._v(" "), _c('th', [_vm._v("Dirección")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Proveedor")]), _vm._v(" "), _c('th', [_vm._v("Combo")]), _vm._v(" "), _c('th', [_vm._v("Horario")]), _vm._v(" "), _c('th', [_vm._v("Subsidio")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Elija...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Atención al Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Administración")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Contaduría")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Área comercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recepción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("DATOS DE ACCESO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Pertenece a")]), _vm._v(" "), _c('th', [_vm._v("Sucursales Administradas")]), _vm._v(" "), _c('th', [_vm._v("Activo")]), _c('th', {
    staticClass: "derecha"
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sucursales Administradas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdfddd90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clientes/FormCliente.vue
// module id = 1163
// module chunks = 5